/** 首页 FAQ — 与飞书文档正文一致 */
export const homeFaqs = [
  {
    question: 'Is GB WhatsApp free to download?',
    answer:
      'Yes. GB WhatsApp is available as a free APK for Android devices. You can download the latest version from <strong>GB Wave</strong> along with installation guides, update instructions, and previous releases.',
  },
  {
    question: 'Can I install GB WhatsApp without uninstalling WhatsApp?',
    answer:
      'Yes, in many cases you can use GB WhatsApp alongside the official WhatsApp if each app uses a different package name. Compatibility may vary depending on the version you install.',
  },
  {
    question: 'Will I lose my chats when updating GB WhatsApp?',
    answer:
      'Not usually. If you install a newer version over your existing app, your chats are generally kept. However, it\'s always recommended to create a local backup before updating.',
  },
  {
    question: 'Why can\'t I install the APK?',
    answer:
      'This is usually caused by disabled <strong>Install Unknown Apps</strong> permission, an incomplete APK download, or an unsupported Android version. Make sure your device meets the minimum requirements before installing.',
  },
  {
    question: 'Does GB WhatsApp work on all Android devices?',
    answer:
      'GB WhatsApp supports most Android devices running <strong>Android 5.0 or later</strong>. Some features or versions may work differently depending on your device model and Android version.',
  },
  {
    question: 'How do I update to the latest version?',
    answer:
      'Download the latest APK from <strong>GB Wave</strong>, then install it over your current version without uninstalling the app whenever possible. Backing up your chats before updating is always recommended.',
  },
  {
    question: 'Can I restore chats after reinstalling GB WhatsApp?',
    answer:
      'Yes. If you have a valid local backup and verify the same phone number during setup, you can usually restore your previous chats and media files.',
  },
  {
    question: 'Can I use two WhatsApp accounts on one phone?',
    answer:
      'Yes. Many users install GB WhatsApp alongside the official WhatsApp to use two different phone numbers on the same Android device. Compatibility depends on your device and the installed version.',
  },
  {
    question: 'What should I do if verification fails?',
    answer:
      'Double-check your phone number, ensure you have a stable internet connection, and request a new verification code. If the issue continues, wait a few minutes before trying again.',
  },
];
